import type {CSSProperties} from 'react';
import {T} from '@territory/tokens';
import {radius, weight} from '../scale.js';

export type WedgeAccountHistoryLook = 'history-older';

const HISTORY_LOOKS = new Set<string>(['history-older']);
export const isWedgeAccountHistoryLook = (look: string): look is WedgeAccountHistoryLook => HISTORY_LOOKS.has(look);

/* Released "Show older" button of the brief History tab (prep-account-history Bv2HistoryTab), off-scale. It is a clear 12px radius box, at
   least 44px tall, with 16px of side padding, a 1px border, 14px semibold type and the accent ink. It sits at the start of its column, so it
   keeps the width of its label. The caller sets the font family (the brief body face). Colors read the --wedge-bv2-* roles, which the
   caller points at the brief scope vars (--bv2-line2 and --bv2-accInk); outside the brief each falls back to a base token. The box is 44px
   tall already, so no look here draws a transparent target (wedgeAccountHistoryDrawsHit). */
const role = (name: string, fallback: string): string => `var(--wedge-bv2-${name}, ${fallback})`;
export const wedgeAccountHistoryDrawsHit = (look: string): boolean => !isWedgeAccountHistoryLook(look);

export function wedgeAccountHistoryStyle(_look: WedgeAccountHistoryLook): CSSProperties {
  return {
    minHeight: 44, padding: '0 16px', borderRadius: radius.lg, border: `1px solid ${role('line2', T.separator)}`, background: 'transparent',
    color: role('acc-ink', T.accent), fontSize: 14, fontWeight: weight.semibold, cursor: 'pointer', alignSelf: 'flex-start',
  };
}
